var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1452 0H8.85352C6.26914 0 4.16602 2.10312 4.16602 4.6875V20.3125C4.16602 22.8969 6.26914 25 8.85352 25H16.1452C18.7296 25 20.8327 22.8969 20.8327 20.3125V4.6875C20.8327 2.10312 18.7296 0 16.1452 0ZM15.4233 1.04167L15.0848 2.05625C14.8712 2.69583 14.2754 3.125 13.6025 3.125H11.3973C10.7243 3.125 10.1285 2.69583 9.91497 2.05625L9.57643 1.04167H15.4233ZM19.791 20.3125C19.791 22.3229 18.1556 23.9583 16.1452 23.9583H8.85352C6.8431 23.9583 5.20768 22.3229 5.20768 20.3125V4.6875C5.20768 2.80208 6.65247 1.26354 8.48997 1.07812L8.92539 2.38542C9.2806 3.45 10.2733 4.16563 11.3962 4.16563H13.6014C14.7243 4.16563 15.7171 3.45 16.0723 2.38542L16.5077 1.07812C18.3452 1.26354 19.79 2.80104 19.79 4.6875L19.791 20.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0618 20.833H10.9368C10.6493 20.833 10.416 21.0663 10.416 21.3538C10.416 21.6413 10.6493 21.8747 10.9368 21.8747H14.0618C14.3493 21.8747 14.5827 21.6413 14.5827 21.3538C14.5827 21.0663 14.3493 20.833 14.0618 20.833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.526e8397073714311f133b92b9422704.svg";
export { ForwardRef as ReactComponent };